import Axios from "axios";

export const task = {
    state: {
        tasks: [],
        currentTask: {},
        searchQuery:""
    },
    mutations: {
        SET_CURRENT_TASK(state: any, payload: Record<string, any>) {
            state.currentTask = payload;
        },
        SET_TASKS(state: any, payload: Array<Record<string, any>> ) {
            state.tasks = payload;
        },
        SET_SEARCH_QUERY(state: any, payload: any) {
            state.searchQuery = payload;
        },
        RESET_STATE(state: any) {
            state.tasks = [];
            state.currentTask = {};
        }
    },
    actions: {
        async actionGetTasks(context: any, payload: Record<string, any>) {

            const pageNumber =
                typeof payload.pageNumber != "undefined"
                    ? payload.pageNumber
                    : 0;

            const pageSize =
                typeof payload.pageSize !== "undefined" ? payload.pageSize : 8;
            let query =
                payload.searchQuery !== undefined
                    ? payload.searchQuery
                    : context.state.querySearch;

            if (query !== undefined) {
                //context.commit("SET_SEARCH_QUERY", query);
                console.info("--query Guardado--", context.state.querySearch);
            }else{
				query = context.state.searchQuery;
                console.log("SearchQuery: ",context.state.searchQuery);
                if(query === undefined){
                    query = "";
                }

			}

            await Axios
                .get(`${Axios.defaults.baseURL}task/teacher?&pageNumber=${pageNumber}&pageSize=${pageSize}${query}`)
                .then(res => {
                    context.commit("SET_TASKS", res.data);
                    console.info("Tareas cargadas Exitosamente", res.data);
                })
                .catch(error => {
                    console.info("error cargando tareas", error);
                });
        },

        async actionGetTask(context: any, payload: Record<string, any>) {

            await Axios
                .get(`${Axios.defaults.baseURL}task/teacher/${payload.taskId}`)
                .then(res => {
                    context.commit("SET_CURRENT_TASK", res.data);
                    console.info("Tarea cargada Exitosamente", res.data);
                })
                .catch(error => {
                    console.info("error cargando tarea", error);
                });
        },

        // PETICIONES A LA API
        async actionSendTaskFeedback(context: any, payload: any) {
            await Axios
                .post(
                `${Axios.defaults.baseURL}task/teacher/feedback`, payload
                )
                .then((res: any) => {
                console.info("Tarea Revisada con exito", res.data);
                })
                .catch((error: any) => {
                console.info(
                    "Error al revisar tarea",
                    payload,
                    error
                );
                });
            },
        actionSetSearchQuery(context: any, payload: any) {
                context.commit("SET_SEARCH_QUERY", payload);
            },
        setTask(context: any, task:any){
                console.log("Cambiando tarea: ",task);
                context.commit("SET_CURRENT_TASK", task);
        }
    },
    getters: {
        getTasks(state: any) {
            return state.tasks;
        },
        getCurrentTask(state: any) {
            return state.currentTask;
        },
    }
};
